import ConnectForm from '@components/shared/ConnectFrom'
import { Message } from '@utils/message'
import moment from 'moment'
import React from 'react'
import { FieldValues, UseFormReturn, UseFormWatch } from 'react-hook-form'
import 'twin.macro'
type FormMethods = UseFormReturn<FieldValues, any>

interface Props {
  stateLabel?: React.ReactNode
  readonly?: boolean
}

const AdminPostForm = ({ stateLabel, readonly }: Props) => {
  const getMaxValueforStartDate = (watch: UseFormWatch<FieldValues>) => {
    if (!watch('endDate')) return ''
    return moment(watch('endDate')).format('YYYY-MM-DDTHH:mm:ss')
  }

  const getMinValueforEndDate = () => {
    return moment().format('YYYY-MM-DDTHH:mm')
  }

  return (
    <ConnectForm>
      {({ register, watch, formState: { errors } }: FormMethods) => (
        <>
          <div tw="text-xl font-bold mb-20">제목</div>
          <input
            {...register('title', {
              required: Message.valid.REQUIRE_TITLE,
            })}
            readOnly={readonly}
            disabled={readonly}
            tw="mb-8 w-full h-40"
            placeholder="제목을 입력해 주세요."
            className="input"
            type="text"
          />
          <div tw="text-base text-red-500 mb-20 h-15">
            {errors?.title?.message}
          </div>
          {!readonly && (
            <>
              <div tw="text-xl font-bold mb-20">기간설정</div>
              <div tw="flex gap-12 content-center items-center mb-3">
                <div>시작일</div>
                <input
                  {...register('startDate', {
                    required: Message.valid.REQUIRE_DATE,
                  })}
                  max={getMaxValueforStartDate(watch)}
                  tw="w-250"
                  className="input"
                  type="datetime-local"
                />
                <div tw="font-bold text-xl px-3">~</div>
                <div>종료일</div>
                <input
                  {...register('endDate', {
                    required: Message.valid.REQUIRE_DATE,
                  })}
                  min={getMinValueforEndDate()}
                  tw="w-250"
                  className="input"
                  type="datetime-local"
                />
              </div>
              <div tw="text-base text-red-500 mb-25 h-10">
                {(errors.startDate || errors.endDate) && (
                  <span>
                    {errors?.startDate?.message || errors?.endDate?.message}
                  </span>
                )}
              </div>
            </>
          )}

          <div tw="w-full mb-20 flex justify-between">
            <div tw="text-xl font-bold">내용</div>
            {stateLabel}
          </div>
          <textarea
            {...register('content', {
              required: Message.valid.REQUIRE_CONTENT,
            })}
            readOnly={readonly}
            disabled={readonly}
            placeholder="내용을 입력해 주세요."
            tw="mb-2 w-full min-h-300 resize-none"
            className="input"
          />
          <div tw="text-base text-red-500 mb-20 h-4">
            {errors?.content?.message}
          </div>
        </>
      )}
    </ConnectForm>
  )
}

export default AdminPostForm
